module.exports = __webpack_public_path__ + "media/images/writer/monitor/mv-img-6e606cb0879ab2f2f09bb776f9ae8a2f.png";